import { usePathname, useRouter } from "next/navigation";
import { useSelector } from "react-redux";

import contentSelectors from "@/store/content/content.selectors";

interface FilterParams {
  arrayFilters: Record<string, string[]>;
  orderBy?: { value: string };
  limit?: number;
}

const useViewFilterFeatures = ({
  getCompanies,
  currentParams,
  currentView,
  controlModal,
  clearSelectedCompanies,
  setArrayFilters,
  setViewParams,
}: {
  getCompanies: any;
  currentParams: FilterParams;
  currentView: any;
  controlModal?: any;
  clearSelectedCompanies?: any;
  setArrayFilters: any;
  setViewParams: any;
}) => {
  const pathname = usePathname();
  const router = useRouter();
  const growingFilters = useSelector(contentSelectors.getGrowingFilters());
  const filterFieldsCount = currentParams?.arrayFilters
    ? Object.values(currentParams.arrayFilters).reduce<number>(
        (acc, cur) => acc + (cur?.length || 0),
        0
      )
    : 0;

  const filterBtnTitle = !filterFieldsCount
    ? "Filter"
    : filterFieldsCount > 1
    ? `Filtered by ${filterFieldsCount} fields`
    : `Filtered by ${filterFieldsCount} field`;

  const onOpenFilterHandler = () => {
    controlModal.onOpen();
    setArrayFilters({
      key: currentView?.id,
      filters: currentParams?.arrayFilters,
    });
  };

  const removeFilterHandler = () => {
    pathname?.includes("/tags") && router.push("/companies");
    clearSelectedCompanies();
    const { ...rest } = currentParams;
    getCompanies({
      params: {
        ...rest,
        arrayFilters: undefined,
        orderBy: currentParams?.orderBy?.value,
        limit: currentParams?.limit,
        page: 1,
      },
    });
    setViewParams({
      key: currentView?.id,
      params: { arrayFilters: undefined },
    });
  };

  return { filterBtnTitle, onOpenFilterHandler, removeFilterHandler };
};

export default useViewFilterFeatures;
